export enum DownloadAttachmentsTypes {
  'LOAD_DOWNLOADATTACHMENTS_REQUEST' = '@attachments/LOAD_DOWNLOADATTACHMENTS_REQUEST',
  'LOAD_DOWNLOADATTACHMENTS_FAILURE' = '@attachments/LOAD_DOWNLOADATTACHMENTS_FAILURE',
}

export interface DownloadAttachment {
  protocolo: number;
  mensagem: number;
}

export interface DownloadAttachmentsState {
  readonly loading: boolean;
  readonly error: boolean;
}
